import { FormModel } from '../../../../../components/Form';
import { Validators } from '../../../../../utils/validators';

export const KycForm = (strings: any, paymentMethodList: { value: any; label: any }[], width = 12): FormModel[] => {
  return [
    {
      label: 'Document Type',
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'documentType',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: width },
      required: true,
      options: paymentMethodList,
    },
    {
      label: 'Document Received',
      value: false,
      type: 'checkbox',
      field: 'isReceived',
      responsive: { xs: 12 },
      placeholder: '',
      validators: [],
      required: false,
    },
  ];
};
